var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8E8;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shift-24px",
    transform: "translate(293 -385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    className: "st0",
    d: "M-283.4,389.5l-6.7,6.7c-0.4,0.4-0.4,1,0,1.4c0,0,0,0,0,0l6.7,6.3c0.4,0.4,1,0.4,1.4,0 c0.2-0.2,0.3-0.4,0.3-0.7v-2.5h9c0.5,0,1-0.4,1-0.9c0,0,0-0.1,0-0.1v-6c0-0.5-0.4-1-0.9-1c0,0-0.1,0-0.1,0h-9v-2.4 c0.1-0.5-0.3-1-0.9-1.1C-282.9,389.1-283.2,389.2-283.4,389.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    x: -293,
    y: 385,
    className: "st1",
    width: 24,
    height: 24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack24Px);
export default __webpack_public_path__ + "static/media/back-24px.ec39f73daaab8b6461c818755ec81000.svg";
export { ForwardRef as ReactComponent };